import { Countries } from '@axo/config/@types/Country.types';

export type TrustPilotDataProps = {
  businessUnit: {
    stars: number;
    trustScore: number;
    displayName: string;
    numberOfReviews: {
      total: number;
      oneStar: number;
      twoStars: number;
      threeStars: number;
      fourStars: number;
      fiveStars: number;
    };
    websiteUrl: string;
  };
  businessEntity: {
    stars: number;
    trustScore: number;
    displayName: string;
    numberOfReviews: {
      total: number;
      oneStar: number;
      twoStars: number;
      threeStars: number;
      fourStars: number;
      fiveStars: number;
    };
    websiteUrl: string;
  };
  reviews:
    | {
        stars: number;
        createdAt: string;
        title: string;
        text: string;
        reviewUrl: string;
        verification?: {
          reviewSource: string;
          createdAt: string;
          isVerified: boolean;
          verificationLevel: string;
          verificationSource: string;
        };
        consumer: {
          displayName: string;
        };
        companyReply: {
          createdAt: string;
          text: string;
        } | null;
      }[]
    | null;
  links: {
    profileUrl: string;
    evaluateUrl: string;
    evaluateEmbedUrl: string;
    consumerWebPageUrl: null;
  };
  starsString: string;
  translations: {
    reviews?: string;
    noReviews?: string;
    main?: string;
    readmore?: string;
    reply?: string;
    firstreviewer?: string;
    noreviewsyet?: string;
    reviewedby?: string;
    replied?: string;
  };
  settings: { customStylesAllowed: boolean; syndicationEnabled?: boolean };
};

export const Markets = Countries.filter((country) => country !== 'GB').map(
  (country) => country.toLowerCase()
);
export type Market = (typeof Markets)[number];
